import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    IconButton,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    useTheme,
    useMediaQuery,
} from '@mui/material'
import { History, KeyboardArrowDown } from '@mui/icons-material'
import { ResponsivePageContainer } from '../../components/PageContainers'
import { Bill } from '../../types/bills'
import { PayNowCard } from '../../components/Payments/PayNowCard'
import { BillingHistory } from './BillingHistory'
import {
    getBillingMonth,
    getCurrency,
    getShortFormDate,
} from '../../helpers/stringHelpers'
import { useAppDispatch } from '../../hooks'
import { fetchBills } from '../../store/Billing/action'

interface Transaction {
    date: string
    type: string
    description: string
    source: string
    amount: string
    balance: string
}

export const ManagePayments = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    const [autoPayEnabled, setAutoPayEnabled] = useState(false)
    const [selectedFilter, setSelectedFilter] = useState('all')
    const [selectedTab, setSelectedTab] = useState('ledger')
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const dispatch = useAppDispatch()


    useEffect(() => {
        dispatch(fetchBills())
    }, [])

    return (
        <ResponsivePageContainer
            title="Payments"
            subtitle="Manage your rent payments and transaction history"
        >
            {/* Amount Due Card */}
            <PayNowCard />

            {/* Transaction History Card */}
            <BillingHistory />
        </ResponsivePageContainer>
    )
}
